import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@lms/ui';
import { Bilingual } from './Bilingual';
import { copy } from '../copy/copy';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between px-6 py-4 border-t border-on-surface/5">
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          leftIcon={<ChevronLeft size={16} />}
          className="text-[10px] uppercase font-bold tracking-widest disabled:opacity-30"
        >
          <Bilingual {...copy.common.previous} />
        </Button>
      </div>

      <div className="text-xs font-body text-on-surface-variant">
        <span className="font-bold text-on-surface">{currentPage}</span> / {totalPages}
      </div>

      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          rightIcon={<ChevronRight size={16} />}
          className="text-[10px] uppercase font-bold tracking-widest disabled:opacity-30"
        >
          <Bilingual {...copy.common.next} />
        </Button>
      </div>
    </div>
  );
}
